<template>
  <div class="form-wrap">
    <label>{{ $t('sites.createSiteHelpHeadline') }}</label>
    <div class="new-site__help-info">
      <img class="new-site__help-image" src="@/assets/werksplan-anlegen.gif" />
      <div class="new-site__help-text">
        {{ $t('sites.createSiteHelpText') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteDrawHelp',
}
</script>

<style scoped>
.new-site__help-info {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  align-items: center;
  padding-top: 12px;
}

.new-site__help-text {
  width: 50%;
  padding-left: 24px;
  line-height: 1.5;
}

.new-site__help-image {
  width: 50%;
  border-radius: 4px;
}
</style>
